import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { QUESTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { QuestionMonitorPage } from '@/features/question/pages/QuestionMonitorPage';
import { monitorPageSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/download-by-class')({
  beforeLoad: () => requirePermission(QUESTION_PERMISSIONS.DOWNLOAD_BY_CLASS_VIEW),
  validateSearch: monitorPageSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Question Download by Class">
      <Suspense fallback={<PageLoader />}>
        <QuestionMonitorPage
          routeId="byClass"
          screen="byClass"
          title="Question Download by Class"
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
